import React, { useState } from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";
import { toast } from "sonner";
import { WEDDING_CONFIG, buildWhatsAppLink, getGuestName } from "../config";

export default function Rsvp() {
  const guestName = getGuestName();
  const [form, setForm] = useState({
    name: guestName || "",
    attendance: "hadir",
    guests: 1,
    message: "",
  });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      toast.error("Mohon isi nama Anda");
      return;
    }
    const labels = {
      hadir: "✅ Hadir",
      tidak_hadir: "❌ Tidak Hadir",
      ragu: "🤔 Belum Pasti",
    };

    const text =
`*KONFIRMASI KEHADIRAN*
Pernikahan ${WEDDING_CONFIG.groom.firstName} & ${WEDDING_CONFIG.bride.firstName}

Nama: ${form.name.trim()}
Kehadiran: ${labels[form.attendance]}
Jumlah Tamu: ${form.guests} orang
${form.message.trim() ? `\nPesan:\n${form.message.trim()}` : ""}

Terima kasih 🙏`;

    window.open(buildWhatsAppLink(text), "_blank");
    toast.success("WhatsApp dibuka — kirim pesan untuk konfirmasi");
  };

  return (
    <Section testId="rsvp-section" className="bg-ivory">
      <SectionTitle overline="Konfirmasi Kehadiran" title="RSVP" italic="" />

      <Reveal>
        <p className="text-center text-charcoal/70 max-w-md mx-auto mb-10 font-serif italic">
          Mohon konfirmasi kehadiran Anda. Pesan akan dikirim via WhatsApp ke mempelai.
        </p>
      </Reveal>

      <Reveal>
        <form onSubmit={submit} className="max-w-xl mx-auto space-y-6" data-testid="rsvp-form">
          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-gold">Nama Lengkap</label>
            <input
              data-testid="rsvp-name-input"
              className="input-elegant"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Tuliskan nama Anda"
              required
            />
          </div>

          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-gold block mb-3">Kehadiran</label>
            <div className="flex flex-wrap gap-3" data-testid="rsvp-attendance-group">
              {[
                { v: "hadir", l: "Hadir" },
                { v: "tidak_hadir", l: "Tidak Hadir" },
                { v: "ragu", l: "Belum Pasti" },
              ].map((o) => (
                <button
                  key={o.v}
                  type="button"
                  data-testid={`rsvp-attendance-${o.v}`}
                  onClick={() => setForm({ ...form, attendance: o.v })}
                  className={`px-5 py-2 text-xs tracking-[0.2em] uppercase border transition-all ${
                    form.attendance === o.v
                      ? "bg-gold text-ivory border-gold"
                      : "bg-transparent text-charcoal border-gold/40 hover:border-gold"
                  }`}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-gold">Jumlah Tamu</label>
            <input
              data-testid="rsvp-guests-input"
              className="input-elegant"
              type="number"
              min="1"
              max="10"
              value={form.guests}
              onChange={(e) => setForm({ ...form, guests: e.target.value })}
            />
          </div>

          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-gold">Pesan (opsional)</label>
            <textarea
              data-testid="rsvp-message-input"
              className="input-elegant resize-none"
              rows="3"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Pesan singkat untuk mempelai..."
            />
          </div>

          <div className="text-center pt-4">
            <button
              type="submit"
              data-testid="rsvp-submit-button"
              className="btn-gold inline-flex items-center gap-2"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.6 6.32A7.85 7.85 0 0012.05 4a7.94 7.94 0 00-6.88 11.91L4 20l4.2-1.1a7.93 7.93 0 003.84.98h.01a7.94 7.94 0 005.55-13.56zm-5.55 12.21a6.6 6.6 0 01-3.36-.92l-.24-.14-2.49.65.66-2.43-.16-.25a6.6 6.6 0 1112.24-3.51 6.6 6.6 0 01-6.65 6.6zm3.62-4.94c-.2-.1-1.17-.58-1.35-.64-.18-.07-.31-.1-.45.1-.13.2-.5.64-.62.77-.11.13-.23.15-.43.05-.2-.1-.84-.31-1.6-.99-.6-.53-1-1.18-1.11-1.38-.12-.2-.01-.31.09-.41.09-.09.2-.23.3-.35.1-.11.13-.2.2-.33.07-.13.03-.25-.02-.35-.05-.1-.45-1.08-.62-1.48-.16-.39-.32-.33-.45-.34h-.38c-.13 0-.35.05-.53.25-.18.2-.7.69-.7 1.67 0 .99.71 1.94.82 2.07.1.13 1.4 2.13 3.4 2.99.47.2.85.33 1.14.42.48.15.92.13 1.27.08.39-.06 1.17-.48 1.34-.94.17-.46.17-.86.12-.94-.05-.08-.18-.13-.38-.23z"/>
              </svg>
              Kirim via WhatsApp
            </button>
          </div>
        </form>
      </Reveal>
    </Section>
  );
}
